"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LArtDeVivreEnUzege() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222221" id="digitale-festung-errichten" className="relative w-full h-[100dvh] min-h-[600px] flex flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/60 z-10 backdrop-blur-[2px]" />
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/cyber_mesh_network_abstract.png)] scale-105 transition-transform duration-[20000ms] ease-linear hover:scale-100 opacity-40 grayscale" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 flex flex-col items-center text-center px-4 md:px-8 transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-6xl md:text-8xl lg:text-[8rem] leading-none text-foreground font-extrabold tracking-tighter uppercase">
          Digitale Festung
        </h1>
        {}
        <span className="font-mono text-2xl md:text-4xl text-primary mt-[-10px] md:mt-[-20px] ml-24 md:ml-48 transform -rotate-1 tracking-widest font-bold">
          Errichten
        </span>
        <p className="font-mono text-sm md:text-base text-muted-foreground mt-8 max-w-2xl tracking-wide uppercase">
          Ganzheitliche Cybersecurity & Infrastrukturberatung für Enterprise-Umgebungen
        </p>
      </div>

      {}
      <div className="absolute bottom-12 md:bottom-16 z-20 flex flex-col items-center animate-bounce">
        <Link to="/SecuritySolutionsPage">
          <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none px-10 py-7 text-lg shadow-[0_0_20px_rgba(0,212,255,0.3)] transition-transform hover:scale-105 font-default font-bold uppercase tracking-wider">
            Sicherheitslösungen
          </Button>
        </Link>
      </div>
    </section>;
}